import { render, staticRenderFns } from "./listCustomersSellers.vue?vue&type=template&id=61679204&"
import script from "./listCustomersSellers.vue?vue&type=script&lang=js&"
export * from "./listCustomersSellers.vue?vue&type=script&lang=js&"
import style0 from "./listCustomersSellers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports